import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { getLeadDetails } from "../../redux/services/leadServices/Lead.Services";

function ViewLead() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [lead, setLead] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchLead = async () => {
    try {
      const res = await getLeadDetails(id);

      console.log("Lead Response:", res.data);

      // API response ke hisab se adjust karo
      setLead(res.data?.data || res.data);
    } catch (error) {
      console.error("Lead Fetch Error:", error);
    } finally {
      setLoading(false);
    }
  };
  const formatDateTime = (date) => {
    return new Date(date)
      .toLocaleString("en-GB", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      })
      .replace(/\//g, "-")
      .replace(",", "");
  };
  useEffect(() => {
    fetchLead();
  }, [id]);

  if (loading) {
    return (
      <div className="text-center mt-5">
        <h4>Loading Lead Details...</h4>
      </div>
    );
  }

  if (!lead) {
    return (
      <div className="text-center mt-5">
        <h4>No Lead Found</h4>
      </div>
    );
  }

  return (
    <>
      <div className="d-flex align-items-center justify-content-between  page-header-breadcrumb">
        <div className="title_member">
          <h4>Lead Details</h4>
          <nav className="page-breadcrumb">
            <Link to="/">Home</Link>
            <span className="mx-2">/</span>
            <span>Lead Details</span>
          </nav>
        </div>
        <div>
          <button className="add-btn" onClick={() => navigate(-1)}>
            Back To Lead List
          </button>
        </div>
      </div>

      {/* Details Card */}
  <div className="main_page">
      <div className="card">
        <div className="card-body">
          <div className="row">
            <div className="col-md-4 mb-3">
              <strong>Lead ID</strong>
              <p>{lead?.lead_id || "-"}</p>
            </div>

            <div className="col-md-4 mb-3">
              <strong>Name</strong>
              <p>{lead?.name || "-"}</p>
            </div>
          

            <div className="col-md-4 mb-3">
              <strong>Mobile</strong>
              <p>{lead?.mobile || "-"}</p>
            </div>

            <div className="col-md-4 mb-3">
              <strong>Email</strong>
              <p>{lead?.email || "-"}</p>
            </div>

            <div className="col-md-4 mb-3">
              <strong>Company Name</strong>
              <p>{lead?.company_name || "-"}</p>
            </div>

            <div className="col-md-4 mb-3">
              <strong>Source</strong>
              <p>{lead?.source || "-"}</p>
            </div>

            <div className="col-md-4 mb-3">
              <strong>Status</strong>
              <p>{lead?.status || "-"}</p>
            </div>

            <div className="col-md-4 mb-3">
              <strong>Priority</strong>
              <p>{lead?.priority || "-"}</p>
            </div>

            <div className="col-md-4 mb-3">
              <strong>Estimate Amount</strong>
              <p>{lead?.estimate_amount || "-"}</p>
            </div>

         

            <div className="col-md-4 mb-3">
              <strong>City</strong>
              <p>{lead?.city || "-"}</p>
            </div>

            <div className="col-md-4 mb-3">
              <strong>State</strong>
              <p>{lead?.state || "-"}</p>
            </div>

            <div className="col-md-4 mb-3">
              <strong>Area</strong>
              <p>{lead?.area || "-"}</p>
            </div>

            <div className="col-md-4 mb-3">
              <strong>Pincode</strong>
              <p>{lead?.pincode || "-"}</p>
            </div>

            <div className="col-md-4 mb-3">
              <strong>Assigned To</strong>
              <p>{lead?.assign_to?.name || "-"}</p>
            </div>

            <div className="col-md-4 mb-3">
              <strong>Assigned By</strong>
              <p>{lead?.assign_by?.name || "-"}</p>
            </div>

            <div className="col-md-4 mb-3">
              <strong>Lead Category</strong>
              <p>{lead?.lead_category || "-"}</p>
            </div>

            <div className="col-md-4 mb-3">
              <strong>Lead Stage</strong>
              <p>{lead?.lead_stage || "-"}</p>
            </div>

            <div className="col-md-4 mb-3">
              <strong>Last Followup</strong>
              <p>{lead?.last_followup || "-"}</p>
            </div>

            <div className="col-md-4 mb-3">
              <strong>Next Followup</strong>
              <p>{lead?.next_followup || "-"}</p>
            </div>
            
            <div className="col-md-4 mb-3">
              <strong>Duplicate Lead</strong>
              <p>{lead?.is_duplicate === "1" ? "Yes" : "No"}</p>
            </div>

            <div className="col-md-4 mb-3">
              <strong>Active Status</strong>
              <p>{lead?.is_active === "1" ? "Active" : "Inactive"}</p>
            </div>

            <div className="col-md-12 mb-3">
              <strong>Address</strong>
              <p>{lead?.address || "-"}</p>
            </div>

            <div className="col-md-12 mb-3">
              <strong>Remarks</strong>
              <p>{lead?.remarks || "-"}</p>
            </div>

            {/* <div className="col-md-12 mb-3">
              <strong>Message</strong>

              <div
                className="border rounded p-3 bg-light"
                style={{
                  maxHeight: "300px",
                  overflowY: "auto",
                  whiteSpace: "pre-wrap",
                }}
              >
                {lead?.message || "-"}
              </div>
            </div> */}
            <div className="col-md-6 mb-3">
              <strong>Created Date</strong>
              <p>{lead?.created_at ? formatDateTime(lead.created_at) : "-"}</p>
            </div>

            <div className="col-md-6 mb-3">
              <strong>Updated Date</strong>
              <p>{lead?.updated_at ? formatDateTime(lead.updated_at) : "-"}</p>
            </div>
          </div>
        </div>
      </div>
  </div>
    </>
  );
}

export default ViewLead;
